module.exports = require("babel-loader");